// LLM generated - Model Claude 4 Sonnet
import React, { useState, useEffect, useContext, useMemo } from 'react';
import Cookies from 'js-cookie';
import { IconInfoCircle } from '@tabler/icons-react';

import { Text } from '~/domains/design-system/Text';
import { FEATURE } from '~/common/enums/feature.enum';
import MessageBanner, { BannerType } from '~/domains/common/components/MessageBanner/MessageBanner';
import { useTreatments } from '~/domains/common/hooks/useTreatments';
import { toSafeMarkup } from '~/domains/common/utils/toSafeMarkup';
import { UserContext } from '~/components/providers/UserProvider';
import { isBrowserFn } from '~/utils/browser';

const MY_CONTESTS_CALLOUT_DISMISSED_BASE_KEY = 'my_contests_callout_dismissed';

function EntriesCallout() {
  const { userId } = useContext(UserContext);
  const { isReady, treatments } = useTreatments([FEATURE.SHOW_MY_CONTESTS_CALLOUT]);
  const { treatment, config } = treatments[FEATURE.SHOW_MY_CONTESTS_CALLOUT];
  const isEnabled = treatment === 'on';
  const [showCallout, setShowCallout] = useState(false);

  // Create dynamic cookie key based on config.key and userId
  const cookieKey = useMemo(() => {
    if (!isBrowserFn() || !userId) return null;

    const baseKey = config?.key
      ? `${MY_CONTESTS_CALLOUT_DISMISSED_BASE_KEY}_${config.key}`
      : MY_CONTESTS_CALLOUT_DISMISSED_BASE_KEY;

    return `${baseKey}_${userId}`;
  }, [config?.key, userId]);

  useEffect(() => {
    if (!cookieKey) {
      setShowCallout(false);
      return;
    }

    const hasBeenDismissed = Cookies.get(cookieKey);
    const shouldShow = isReady && isEnabled && !hasBeenDismissed;
    setShowCallout(shouldShow);
  }, [isReady, isEnabled, cookieKey]);

  if (!showCallout) {
    return null;
  }

  const message: string | undefined = config?.message;

  if (!message) {
    return null;
  }

  return (
    <MessageBanner
      Icon={IconInfoCircle}
      type={config?.type || BannerType.INFO}
      onClose={() => {
        if (cookieKey) {
          Cookies.set(cookieKey, 'true', { expires: 365 });
        }
        setShowCallout(false);
      }}
    >
      <Text tag="div" dangerouslySetInnerHTML={{ __html: toSafeMarkup(message) }} />
    </MessageBanner>
  );
}

export default EntriesCallout;
